import {
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { NavLink } from "react-router-dom";
import { Route } from "@/types/general";
import type { SidebarSection } from "../useSidebarSections";
import { sidebarNavState } from "@/features/report/v2/ReportKindDialog";

export default function Collapsed({
  sections,
}: {
  sections: SidebarSection[];
}) {
  return (
    <div className="flex flex-col items-center gap-0.5 pt-1">
      {sections.map((section: any, gi: number) => (
        <SidebarGroup
          key={section.label || section.group || gi}
          className="w-full px-0 py-1 transition-[padding] duration-200 ease-linear"
        >
          {/* slim divider separates each section in the icon rail */}
          {gi > 0 && (
            <div
              className="mx-auto mb-1.5 h-px w-7 rounded-full bg-[#218760]/15"
              aria-hidden
            />
          )}
          <SidebarGroupContent className="flex items-center justify-center transition-all duration-200 ease-linear">
            <SidebarMenu className="w-full items-center gap-1 transition-all duration-200 ease-linear">
              {section.routes?.map((route: Route) => {
                const routeId = route._id;
                return (
                  <SidebarMenuItem
                    key={route.path}
                    className="flex w-full justify-center"
                  >
                    <NavLink
                      to={route.path}
                      // "Report" opens the reports page, which then asks Standard vs Custom.
                      state={sidebarNavState(route.path, { routeId })}
                      className="block"
                    >
                      {({ isActive }) => (
                        <SidebarMenuButton
                          tooltip={route.label}
                          isActive={isActive}
                          className="mx-auto flex !size-9 items-center justify-center rounded-[10px] !p-0 text-[#505e59] transition-colors hover:bg-[#218760]/[0.08] hover:text-[#156548] data-[active=true]:bg-[#218760]/[0.12] data-[active=true]:font-medium data-[active=true]:text-[#156548] data-[active=true]:shadow-[inset_0_0_0_1px_rgba(33,135,96,0.18)] [&>svg]:size-[18px]"
                        >
                          <route.icon />
                          <span className="sr-only">{route.label}</span>
                        </SidebarMenuButton>
                      )}
                    </NavLink>
                  </SidebarMenuItem>
                );
              })}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      ))}
    </div>
  );
}
